import { queryBuilderLastPresets, queryBuilderNextPresets } from 'utils/relativeDateTime';
import BasePanel from './BasePanel';
import { PresetListContainer, PresetItem, PresetsContainer } from './PresetsPanel.styled';

// type Props = {
//   /** The relative start date/time range. */
//   startRange: string,
//   /** The relative end date/time range. */
//   endRange: string,
//   /** Callback function when date/time range changes. */
//   onRangeChange: () => void,
//   /** List of last presets to show. */
//   presetsLast: [],
//   /** List of next presets to show. */
//   presetsNext: [],
// };

const defaultProps = {
  presetsLast: queryBuilderLastPresets,
  presetsNext: queryBuilderNextPresets,
};

const QueryBuilderPresetsPanel = (props) => {
  const { startRange, endRange, onRangeChange, presetsLast, presetsNext } = props;

  /**
   * createPreset
   * Creates a preset link.
   * @param { Object } preset: Th epreset object containing the start range, end range and label.
   * @param { String } key: Key of the preset since this is generated in a loop.
   * @returns { React.Component } The preset link.
   */
  const createPreset = (preset, key) => {
    const { startRange: startRangeFormat, endRange: endRangeFormat, label } = preset;
    const isSelected = startRange === startRangeFormat && endRange === endRangeFormat;

    /**
     * handleClick
     * Callback function when a preset is clicked.
     * @return { void }
     */
    const handleClick = () => {
      onRangeChange({
        startRange: startRangeFormat,
        endRange: endRangeFormat,
        label,
        closeOnChange: true,
      });
    };

    return (
      <PresetItem key={key} onClick={handleClick} data-selected={isSelected}>
        {label}
      </PresetItem>
    );
  };

  const getPresets = (presetList) =>
    Object.keys(presetList).map((key, index) => createPreset(presetList[key], `${key} - ${index}`));

  return (
    <BasePanel title="Presets" {...props}>
      <PresetsContainer>
        <PresetListContainer>{getPresets(presetsLast)}</PresetListContainer>
        <PresetListContainer>{getPresets(presetsNext)}</PresetListContainer>
      </PresetsContainer>
    </BasePanel>
  );
};

export default QueryBuilderPresetsPanel;
QueryBuilderPresetsPanel.defaultProps = defaultProps;
